export default __webpack_public_path__ + "static/ppq-modal-images-e21d7c60cb93090023e402704b1ca834.png";